import React from "react";

// https://www.svgrepo.com/svg/522418/menu
// https://www.svgrepo.com/author/Luka%20Marr/

/**
 * Renders the menu button SVG icon.
 */
export const MenuIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 24 24">
      <g stroke="currentColor">
        <path d="M6 12H18" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6 15.5H18" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6 8.5H18" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  );
};
